<template>
  <v-app>
    <notifyWrapper/>
    <RefreshAppAlert />
    <!-- APPLICATION BAR  -->
    <v-app-bar
      id="home-app-bar"
      flat
      app
      color="#B0DBD8"
      style="border-bottom: solid"
    >
      <div style="background-color: transparent; color: black">
        <img
          src="@/assets/it-logo-black.svg"
          height="33px"
          class="pl-3"
          @click="$routerCore.GoToHomePage()"
        />
      </div>
      <!--  -->

      <v-spacer />
      <v-btn text small to="discoverPage">Discover</v-btn>
      <v-btn text small>Bookmarks</v-btn>
      <v-btn text small>Publish</v-btn>
      <v-btn text small>Manage</v-btn>

      <!-- <lang-switcher /> -->
    </v-app-bar>

    <!-- CONTENT -->
    <v-main class="d-flex justify-center" style="background: #f1f4f6">
      <!-- <v-progress-linear
        v-if="loader"
        indeterminate
        height="5"
        color="primary"
        absolute
      ></v-progress-linear> -->
      <v-container style="width: 75%">
        <dr-layout-placeholder
          :model="{ $ID: 'pl3' + this.routeName, Name: 'Main' }"
        ></dr-layout-placeholder>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import NotifyWrapper from '@/components/NotifyWrapper'
import RefreshAppAlert from '@/components/RefreshAppAlert'
export default {
  name: 'HorizontalLayout',
  components: {
    NotifyWrapper,
    RefreshAppAlert
  },
  watch: {
    isUserAuthenticated(val) {
      if (!val) {
        this.$routerCore.RedirectAfterLogin()
      }
    }
  },
  data: () => ({
    drawer: true,
    minidrawer: true,
    items: ['Discover', 'Photos', 'About'],
    needDefaultImage: false
  }),
  computed: {
    routeName() {
      return this.$route.name
    },
    sidebarItems() {
      return this.$store.getters.AppNavigation
    },
    isUserAuthenticated() {
      return this.$authCore.isAuthenticated
    },
    loader() {
      return this.$store.getters.getProcessing
    }
  },
  methods: {
    setModeDrawer(value) {
      this.minidrawer = value
    },
    load() {
      this.needDefaultImage = false
    },
    error() {
      this.needDefaultImage = true
    }
  }
}
</script>

<style lang="scss" >
nav.v-navigation-drawer {
  box-shadow: 0 0px 18px 0px rgba(0, 0, 0, 0.06);
}
.small-logo {
  display: none;
}
.logo {
  height: 75px;
  background: #fafbfc;
  display: flex;
  align-items: center;
}
.v-navigation-drawer--mini-variant {
  .full-logo {
    display: none;
  }
  .small-logo {
    display: block;
  }
}

.drawer-toggler {
  $border: 1px solid #e2e5e7;
  display: flex;
  position: absolute;
  width: 20px;
  height: 20px;
  right: 0;
  top: 25px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-left: $border;
  border-top: $border;
  border-bottom: $border;
  cursor: pointer;
  z-index: 1000;
  i {
    display: block;
    font-size: 20px;
  }
}
</style>